<div class="popup-container">
    <div class="icon-wrapper">
        <qpoint-icon icon="vector-polygon" [iconType]="'regular'"></qpoint-icon>
    </div>
    <div class="info-wrapper" *ngIf="scalingFactor$ | async; else noScalingFactor">
        <div class="row flex">
            <div class="col">{{ circumferenceLabel }}:</div>
            <div class="col value">{{ circumference | qPointNumberFormat:2 }}</div>
            <div class="col-auto unit">{{ 'm' | qPointTranslateUnit }}</div>
        </div>
        <div class="row">
            <div class="col">{{ areaLabel }}:</div>
            <div class="col value">{{ area | qPointNumberFormat:2 }}</div>
            <div class="col-auto unit">{{ 'm²' | qPointTranslateUnit }}</div>
        </div>
    </div>
    <ng-template #noScalingFactor>
        <div class="info-wrapper">
          <ng-container *ngIf="scalingFactorRequiredTemplate; else textTemplate">
            <ng-container *ngTemplateOutlet="scalingFactorRequiredTemplate"></ng-container>
          </ng-container>
          <ng-template #textTemplate>
            {{ scalingFactorRequiredText }}
          </ng-template>
        </div>
    </ng-template>
</div>
